<template>
    <div class="mt-n16" v-resize="onResize">
        <v-main class="d-flex d-md-none">
            <v-row class="mb-n6">
                <v-col cols="6">
                    <h2 class="my4"><span query-key="ordered_at" @click="getOrderedData"><v-icon>mdi-cards-playing-outline</v-icon> 진행 내역</span> <span v-if="orders.total > 0" class="headline">({{ orders.total }})</span></h2>
                </v-col>
                <v-col cols="6">
<!--                    <ToOrderDialog v-bind:type="'order'" v-bind:mode="'new'"></ToOrderDialog>-->
                    <v-btn icon outlined class="mr-3 mt-n1 d-none d-md-flex" style="float:right" @click="getOrders">
                        <v-icon>mdi-card-search</v-icon>
                    </v-btn>
                    <v-text-field
                            label="검색하세요 :)"
                            outlined
                            dense
                            clearable
                            v-model="orderSearchText"
                            @keydown.enter="setKeywordAndGetOrders"
                            class="mr-3 mt-n1"
                            style="float:right;"
                    ></v-text-field>
                    <v-checkbox
                            v-model="displayDone"
                            :label="`완료 보기`"
                            class="mr-5 mt-0"
                            style="float:right;"
                    ></v-checkbox>
                </v-col>
            </v-row>
            <v-simple-table>
                <template v-slot:default>
                    <thead>
                        <tr>
<!--                            <th class="pl-1 text-left">복사</th>-->
<!--                            <th class="pl-0 text-left" query-key="name" @click="getOrderedData">거래처</th>-->
<!--                            <th class="pl-0 text-left" query-key="estimateDate" @click="getOrderedData">시작일</th>-->
                            <th class="pl-0 text-center" query-key="dueDate" @click="getOrderedData" style="min-width:50px">납품일</th>
<!--                            <th class="pl-0 text-left" query-key="category" @click="getOrderedData">품목</th>-->
                            <th class="pl-0 text-center" query-key="title" @click="getOrderedData">작업명</th>
                            <th class="text-center px-4">진행</th>
<!--                            <th class="pl-0 text-left" query-key="designStatus" @click="getOrderedData">시안확인</th>-->
                            <th class="pl-0 text-center" query-key="paymentStatus" @click="getOrderedData">결제</th>
<!--                            <th class="pl-0 text-left" query-key="taxStatus" @click="getOrderedData">세금계산</th>-->
<!--                            <th class="pl-0 text-left">출력</th>-->
<!--                            <th class="pl-0 text-left">알림</th>-->
<!--                            <th class="pl-0 text-right">삭제</th>-->
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="order in orders.data" :key="order.orderId" dense>
<!--                            <td class="">-->
<!--                                <ToOrderDialog v-bind:type="'order'" v-bind:order-id="order.orderId" v-bind:mode="'copy'"></ToOrderDialog>-->
<!--                            </td>-->
<!--                            <td v-if="order.clientName" class="caption pl-0">{{ order.clientName }}</td>-->
<!--                            <td v-else><strong style="color: deeppink" class="'caption">[ 미 입 력 ]</strong></td>-->
<!--                            <td class="caption font-weight-medium pl-0">{{ order.estimateDate }}</td>-->
                            <td class="caption font-weight-medium pl-0">{{ order.dueDate.substr(3, 7) }}</td>
<!--                            <td class="caption pl-0">{{ order.category }}</td>-->
                            <td class="pl-0">
                                <ToOrderDialog v-if="mobileFlag" v-bind:type="'order'" v-bind:order-id="order.orderId" v-bind:mode="'string'" v-bind:display-string="order.title" :is-urgent="order.urgency" ref="toOrderButton"></ToOrderDialog>
                                <HasDraftImageButton v-if="mobileFlag" :filePath="order.filePath" :description="order.description"></HasDraftImageButton>
                            </td>
                            <td class="text-center px-4">
                                <OrderStatusButton v-if="mobileFlag" :order-id="order.orderId" v-bind:title="order.title" :order-process-status="order.orderProcessStatus" :disable="true"></OrderStatusButton>
<!--                            </td>-->
<!--                            <td>-->
<!--                                <DesignStatusButton :order-id="order.orderId" :design-status="order.designStatus"></DesignStatusButton>-->
<!--                            </td>-->
                            <td class="text-center">
                                <PaymentStatusButton v-if="mobileFlag" :order-id="order.orderId" :payment-status="order.paymentStatus" :disable="true"></PaymentStatusButton>
                            </td>
<!--                            <td>-->
<!--                                <TaxStatusButton :order-id="order.orderId" :tax-status="order.taxStatus"></TaxStatusButton>-->
<!--                            </td>-->
<!--                            <td>-->
<!--                                <PrintOrderButton :order-id="order.orderId"></PrintOrderButton>-->
<!--                            </td>-->
<!--                            <td>-->
<!--                                <SendMessageButton :order-id="order.orderId"></SendMessageButton>-->
<!--                            </td>-->
<!--                            <td class="text-right">-->
<!--                                <DeleteOrderButton :order-id="order.orderId"></DeleteOrderButton>-->
<!--                            </td>-->
                        </tr>

                        <tr v-if="orders.length == 0">
                            <td colspan="13" class="no-data">
                                표시할 데이터가 없습니다.
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>

            <v-container v-if="totalPages > 1" class="text-center">
                <v-pagination
                        v-model="page"
                        :length="totalPages"
                        circle
                ></v-pagination>
            </v-container>
        </v-main>

        <v-main class="d-none d-md-block">
            <v-row class="mb-n6">
                <v-col cols="6">
                    <h2 class="my4"><span query-key="ordered_at" @click="getOrderedData"><v-icon>mdi-cards-playing-outline</v-icon> 작업 진행 내역 조회</span> <span v-if="orders.total > 0" class="headline">({{ orders.total }})</span> <span class="headline caption">정렬:{{ orderConditionNow }}</span></h2>
                </v-col>
                <v-col cols="6">
                    <ToOrderDialog v-bind:type="'order'" v-bind:mode="'new'"></ToOrderDialog>
                    <v-btn icon outlined class="mr-3 mt-n1" style="float:right" @click="getOrders">
                        <v-icon>mdi-card-search</v-icon>
                    </v-btn>
                    <v-text-field
                            label="검색어를 입력하세요"
                            outlined
                            dense
                            clearable
                            v-model="orderSearchText"
                            @keydown.enter="setKeywordAndGetOrders"
                            class="mr-3 mt-n1"
                            style="float:right;"
                    ></v-text-field>
                    <v-checkbox
                            v-model="displayDone"
                            :label="`완료 작업 보기`"
                            class="mr-5 mt-0"
                            style="float:right;"
                    ></v-checkbox>
                </v-col>
            </v-row>
            <v-simple-table>
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th class="pl-1 text-left">복사</th>
                        <th class="pl-0 text-left" query-key="name" @click="getOrderedData">거래처</th>
                        <th class="pl-0 text-left" query-key="estimateDate" @click="getOrderedData">시작일</th>
                        <th class="pl-0 text-left" query-key="dueDate" @click="getOrderedData">납품예정일</th>
                        <th class="pl-0 text-left" query-key="category" @click="getOrderedData">품목</th>
                        <th class="pl-0 text-left" query-key="title" @click="getOrderedData">작업명</th>
                        <th class="pl-0 text-left">진행상태</th>
                        <th class="pl-0 text-left" query-key="designStatus" @click="getOrderedData">시안확인</th>
                        <th class="pl-0 text-left" query-key="paymentStatus" @click="getOrderedData">결제상태</th>
                        <th class="pl-0 text-left" query-key="taxStatus" @click="getOrderedData">세금계산</th>
                        <th class="pl-0 text-left">출력</th>
                        <th class="pl-0 text-left">알림</th>
                        <th class="pl-0 text-right">삭제</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="order in orders.data" :key="order.orderId" dense>
                        <td class="">
                            <ToOrderDialog v-if="pcFlag" v-bind:type="'order'" v-bind:order-id="order.orderId" v-bind:mode="'copy'"></ToOrderDialog>
                        </td>
                        <td v-if="order.clientName" class="caption pl-0">{{ order.clientName }}</td>
                        <td v-else><strong style="color: deeppink" class="'caption">[ 미 입 력 ]</strong></td>
                        <td class="caption font-weight-medium pl-0">{{ order.estimateDate }}</td>
                        <td class="caption font-weight-medium pl-0">{{ order.dueDate }}</td>
                        <td class="caption pl-0">{{ order.category }}</td>
                        <td class="pl-0">
                            <ToOrderDialog v-if="pcFlag" v-bind:type="'order'" v-bind:order-id="order.orderId" v-bind:mode="'string'" v-bind:display-string="order.title" v-bind:is-urgent="order.urgency" ref="toOrderButton"></ToOrderDialog>
                            <HasDraftImageButton v-if="pcFlag" :filePath="order.filePath" :filePath2="order.filePath2"  :filePath3="order.filePath3" :filePath4="order.filePath4" :filePath5="order.filePath5" :description="order.description"></HasDraftImageButton>
                        </td>
                        <td>
                            <OrderStatusButton v-if="pcFlag" :order-id="order.orderId" :order-process-status="order.orderProcessStatus" :disable="orderStatusDisable"></OrderStatusButton>
                        </td>
                        <td>
                            <DesignStatusButton v-if="pcFlag" :order-id="order.orderId" :design-status="order.designStatus"></DesignStatusButton>
                        </td>
                        <td>
                            <PaymentStatusButton v-if="pcFlag" :order-id="order.orderId" :payment-status="order.paymentStatus"></PaymentStatusButton>
                        </td>
                        <td>
                            <TaxStatusButton v-if="pcFlag" :order-id="order.orderId" :tax-status="order.taxStatus"></TaxStatusButton>
                        </td>
                        <td>
                            <PrintOrderButton v-if="pcFlag" :order-id="order.orderId"></PrintOrderButton>
                        </td>
                        <td>
                            <SendMessageButton v-if="pcFlag" :order-id="order.orderId"></SendMessageButton>
                        </td>
                        <td class="text-right">
                            <DeleteOrderButton :order-id="order.orderId"></DeleteOrderButton>
                        </td>
                    </tr>

                    <tr v-if="orders.length == 0">
                        <td colspan="13" class="no-data">
                            표시할 데이터가 없습니다.
                        </td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>

            <v-container v-if="totalPages > 1" class="text-center">
                <v-pagination
                        v-model="page"
                        :length="totalPages"
                        circle
                ></v-pagination>
            </v-container>
        </v-main>
    </div>
</template>

<script>
import ToOrderDialog from "@/components/order/ToOrderDialog";
import OrderStatusButton from "@/components/order/button/OrderStatusButton";
import DesignStatusButton from "@/components/order/button/DesignStatusButton";
import PaymentStatusButton from "@/components/order/button/PaymentStatusButton";
import TaxStatusButton from "@/components/order/button/TaxStatusButton";
import DeleteOrderButton from "@/components/order/button/DeleteOrderButton";
import HasDraftImageButton from "@/components/order/button/HasDraftImageButton";
import PrintOrderButton from "@/components/order/button/PrintOrderButton"
import SendMessageButton from "@/components/order/button/SendMessageButton"

export default {
    name: 'OrderRows',
    components: {
        ToOrderDialog,
        OrderStatusButton,
        DesignStatusButton,
        PaymentStatusButton,
        TaxStatusButton,
        DeleteOrderButton,
        HasDraftImageButton,
        PrintOrderButton,
        SendMessageButton
    },
    data () {
        return {
            orderConditionNow: "",
            orderSearchText: "",
            orders: [],
            totalPages: 1,
            page: 1,
            imageDialog: false,
            displayDone: null,
            orderStatusDisable: false,
            mobileFlag: false,
            pcFlag: false
        }
    },
    watch: {
        // orderSearchText: async function(newText) {
        //     const queryOptions = await this.$store.getters.getOrderQueryOptions
        //     queryOptions.queryText = newText
        //     await this.$store.dispatch('setOrderQueryOptions', queryOptions)
        //
        //     if(newText == ''){
        //         await this.getOrders()
        //     }
        // },
        displayDone: async function(value, oldValue) {
            const queryOptions = await this.$store.getters.getOrderQueryOptions
            queryOptions.displayDone = value
            if(value == false && oldValue == true){
                this.page = 1
                queryOptions.page = 1
            }
            await this.$store.dispatch('setOrderQueryOptions', queryOptions)
            await this.getOrders()
        },
        page: async function(newPage, oldPage) {

            if(newPage != oldPage){

                const queryOptions = await this.$store.getters.getOrderQueryOptions
                queryOptions.page = newPage
                await this.$store.dispatch('setOrderQueryOptions', queryOptions)
                await this.getOrders()

            }

        }
    },
    methods: {
        async getOrders() {
            await this.$store.dispatch('getOrders')
            this.orders = await this.$store.getters.getOrders
            this.totalPages = this.orders.lastPage
            if(this.page > this.totalPages){
                this.page = 1
            }
        },
        async setKeywordAndGetOrders() {
            const queryOptions = await this.$store.getters.getOrderQueryOptions
            queryOptions.queryText = this.orderSearchText
            await this.$store.dispatch('setOrderQueryOptions', queryOptions)
            this.orders = []
            await this.getOrders()
        },
        async getOrderedData(e) {

            const key = e.currentTarget.getAttribute('query-key')
            const queryOptions = await this.$store.getters.getOrderQueryOptions

            queryOptions.prevKey = key

            if(queryOptions.queryKey != key){
                queryOptions.queryKey = key
                queryOptions.queryOrder = 'desc'
            }else if(queryOptions.queryKey == key){
                if(queryOptions.queryOrder == 'desc'){
                    queryOptions.queryOrder = 'asc'
                }else{
                    queryOptions.queryOrder = 'desc'
                }
            }

            this.getOrderConditionNow(key, queryOptions.queryOrder)

            await this.$store.dispatch('setOrderQueryOptions', queryOptions)
            await this.getOrders()

        },
        getOrderConditionNow(key, order) {

            //정렬 기준 표기
            if(key == 'ordered_at') {
                this.orderConditionNow = "입력시간"
                if(order == 'asc'){
                    this.orderConditionNow += " ▲"
                }else{
                    this.orderConditionNow += " ▼"
                }
            }else if(key == 'name') {
                this.orderConditionNow = "거래처"
                if(order == 'asc'){
                    this.orderConditionNow += " ▲"
                }else{
                    this.orderConditionNow += " ▼"
                }
            }else if(key == 'estimateDate') {
                this.orderConditionNow = "시작일"
                if(order == 'asc'){
                    this.orderConditionNow += " ▲"
                }else{
                    this.orderConditionNow += " ▼"
                }
            }else if(key == 'dueDate') {
                this.orderConditionNow = "납품예정일"
                if(order == 'asc'){
                    this.orderConditionNow += " ▲"
                }else{
                    this.orderConditionNow += " ▼"
                }
            }else if(key == 'category') {
                this.orderConditionNow = "품목"
                if(order == 'asc'){
                    this.orderConditionNow += " ▲"
                }else{
                    this.orderConditionNow += " ▼"
                }
            }else if(key == 'title') {
                this.orderConditionNow = "작업명"
                if(order == 'asc'){
                    this.orderConditionNow += " ▲"
                }else{
                    this.orderConditionNow += " ▼"
                }
            }else if(key == 'designStatus') {
                this.orderConditionNow = "시안확인"
                if(order == 'asc'){
                    this.orderConditionNow += " ▲"
                }else{
                    this.orderConditionNow += " ▼"
                }
            }else if(key == 'paymentStatus') {
                this.orderConditionNow = "결제상태"
                if(order == 'asc'){
                    this.orderConditionNow += " ▲"
                }else{
                    this.orderConditionNow += " ▼"
                }
            }else if(key == 'taxStatus') {
                this.orderConditionNow = "세금계산"
                if(order == 'asc'){
                    this.orderConditionNow += " ▲"
                }else{
                    this.orderConditionNow += " ▼"
                }
            }

        },
        onResize: function() {

            switch(this.$vuetify.breakpoint.name) {
                case 'xs':
                case 'sm':
                case 'md':
                    this.orderStatusDisable = true
                    break
                case 'lg':
                case 'xl':
                    this.orderStatusDisable = false
                    break
                default:
                    this.orderStatusDisable = false
            }

        }
    },
    created: async function() {
        await this.getOrders()
        setInterval(this.getOrders, this.$store.getters.getCommonRefreshInterval)
        this.displayDone = await this.$store.getters.getDisplayDone

        const queryOptions = await this.$store.getters.getOrderQueryOptions
        this.page = queryOptions.page
        if (!this.orderSearchText){
            queryOptions.queryText = ''
            await this.$store.dispatch('setOrderQueryOptions', queryOptions)
        }

        this.getOrderConditionNow(queryOptions.queryKey, queryOptions.queryOrder)

        switch(this.$vuetify.breakpoint.name) {
            case 'xl':
            case 'lg':
            case 'md':
                this.mobileFlag = false
                this.pcFlag = true
                break
            case 'sm':
            case 'xs':
                this.mobileFlag = true
                this.pcFlag = false
                break
        }

    },

    mounted() {
        this.onResize()
    }
}
</script>

<style scoped>
    .no-data { text-align: center; background-color: aliceblue; }
    table, tr, td { padding: 0em }
    tr, td {
        padding: 2px !important;
    }
</style>